import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Input } from "reactstrap";
import Select from "react-select";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  Toolbar,
  IconButton,
  Alert,
  Stack,
  CircularProgress,
} from "@mui/material";
import {
  AddBox,
  Refresh,
  Search,
  RemoveRedEye,
  Edit,
  Delete,
  Close,
  Cancel,
  Check,
  Save,
} from "@mui/icons-material";
import {
  apiBillingUserSettingsList,
  apiBillingUserSettingsDetail,
  apiBillingUserSettingsSave,
  apiBillingUserSettingsDelete,
  apiBillingUserCreditBalance,
} from "../../Service/api";

const styleHeader = {
  borderLeft: 6,
  borderColor: "#2f55a2",
  color: "#FFF",
  maxHeight: 100,
  padding: 16,
  paddingBottom: 24,
};

const stylesListComent = {
  inline: {
    display: "inline",
  },
};

const stylesListDialog = {
  inline: {
    display: "inline",
  },
};

const styleDialog = {
  appBar: { position: "relative", backgroundColor: "#03101e" },
  title: { marginLeft: 0, flex: 1, fontSize: 16 },
};

const selectStyles = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

const filterPaymentModeOptions = [
  { value: "", label: "All Payment Mode" },
  { value: "manual", label: "manual" },
  { value: "gateway", label: "gateway" },
];
const filterProviderOptions = [
  { value: "", label: "All Provider" },
  { value: "manual", label: "manual" },
  { value: "langitpay", label: "langitpay" },
];
const filterStatusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];
const paymentModeOptions = [
  { value: "manual", label: "manual" },
  { value: "gateway", label: "gateway" },
];
const providerOptions = [
  { value: "manual", label: "manual" },
  { value: "langitpay", label: "langitpay" },
];
const chargeSourceOptions = [
  { value: "credit", label: "credit" },
  { value: "invoice", label: "invoice" },
  { value: "wallet", label: "wallet" },
];
const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

class UserBillingSettingsPage extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      tableData: [],
      loading: false,
      filterSearch: "",
      filterPaymentMode: filterPaymentModeOptions[0],
      filterProvider: filterProviderOptions[0],
      filterStatus: filterStatusOptions[0],
      openSuccess: false,
      openSuccessText: "",
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      openAlertDelete: false,
      itemDeleted: {},
      showLoadingDelete: false,
      setOpenForm: false,
      formMode: "add",
      submitLoading: false,
      form: this.defaultForm(),
    };

    this.tableColumns = [
      { Header: "No", accessor: "no", width: 70, headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      { Header: "Full Name", accessor: "full_name", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "left", display: "flex", justifyContent: "flex-start", alignItems: "center" } },
      { Header: "Email", accessor: "email", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "left", display: "flex", justifyContent: "flex-start", alignItems: "center" } },
      { Header: "Phone", accessor: "phoneno", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      { Header: "Payment Mode", accessor: "payment_mode", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      { Header: "Provider", accessor: "payment_provider", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }, Cell: (e) => (e.original.payment_provider ? e.original.payment_provider : "-") },
      { Header: "Fee Percent", accessor: "fee_percent_display", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      { Header: "Charge Source", accessor: "charge_source", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      { Header: "Status", accessor: "status_label", headerStyle: { fontWeight: "bold", fontSize: 14 }, style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" } },
      {
        Header: "Action",
        accessor: "action",
        filterable: false,
        width: 320,
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: { textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" },
        Cell: (e) => this.renderActionButtons(e.original),
      },
    ];
  }

  componentDidMount() {
    this.doLoadData();
    window.scrollTo(0, 0);
  }

  defaultForm = () => ({
    id: null,
    email: "",
    phoneno: "",
    payment_mode: "manual",
    payment_provider: "",
    fee_percent: "0",
    charge_source: "credit",
    is_active: 1,
    config_json: "",
    credit_balance: null,
  });

  getOption = (options, value) =>
    options.find((x) => String(x.value) === String(value)) || null;

  getFilterParams = () => ({
    search: this.state.filterSearch,
    payment_mode: this.state.filterPaymentMode.value,
    payment_provider: this.state.filterProvider.value,
    is_active: this.state.filterStatus.value,
  });

  doLoadData = () => {
    this.setState({ loading: true });
    apiBillingUserSettingsList(this.getFilterParams())
      .then((res) => {
        const data = res.data;
        if (data.status !== "ok") {
          this.setState({ tableData: [] });
          if (data.message) this.showValidation("Failed", data.message);
          return;
        }
        const rows = Array.isArray(data.records) ? data.records : [];
        this.setState({
          tableData: rows.map((row, i) => ({
            ...row,
            no: i + 1,
            fee_percent_display: `${Number(row.fee_percent || 0).toFixed(4)}%`,
            status_label: Number(row.is_active) === 1 ? "Active" : "Inactive",
          })),
        });
      })
      .catch((err) => {
        console.error(err);
        this.showValidation("Failed", "Unable to load billing settings");
      })
      .finally(() => this.setState({ loading: false }));
  };

  pressReset = () =>
    this.setState(
      {
        openSuccess: false,
        openSuccessText: "",
        filterSearch: "",
        filterPaymentMode: filterPaymentModeOptions[0],
        filterProvider: filterProviderOptions[0],
        filterStatus: filterStatusOptions[0],
      },
      this.doLoadData
    );

  showValidation = (title, body) =>
    this.setState({ openValidation: true, titleValidation: title, titleBody: body });

  handleCloseValidation = () =>
    this.setState({ openValidation: false, titleValidation: "", titleBody: "" });

  renderSuccess = () =>
    this.state.openSuccess ? (
      <div style={{ margin: 10 }}>
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert variant="filled" severity="success" sx={{ mb: 2 }}>
            {this.state.openSuccessText}
          </Alert>
        </Stack>
      </div>
    ) : null;

  openAdd = () => this.setState({ setOpenForm: true, formMode: "add", form: this.defaultForm() });

  openView = (row) => this.fetchDetail(row.id, "view");
  openEdit = (row) => this.fetchDetail(row.id, "edit");

  fetchDetail = (id, mode) => {
    this.setState({ loading: true });
    apiBillingUserSettingsDetail({ id })
      .then((res) => {
        const data = res.data;
        if (data.status !== "ok" || !data.record) {
          this.showValidation("Failed", data.message || "Data not found");
          return;
        }
        const rec = data.record;
        this.setState({
          setOpenForm: true,
          formMode: mode,
          form: {
            id: rec.id,
            email: rec.email || "",
            phoneno: rec.phoneno || "",
            payment_mode: rec.payment_mode || "manual",
            payment_provider: rec.payment_provider || "",
            fee_percent: String(rec.fee_percent !== undefined && rec.fee_percent !== null ? rec.fee_percent : 0),
            charge_source: rec.charge_source || "credit",
            is_active: Number(rec.is_active) === 1 ? 1 : 0,
            config_json: rec.config_text || "",
            credit_balance: rec.credit_balance !== undefined && rec.credit_balance !== null ? rec.credit_balance : null,
          },
        });
      })
      .catch((err) => {
        console.error(err);
        this.showValidation("Failed", "Unable to get detail data");
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleCloseForm = () => this.setState({ setOpenForm: false, formMode: "add", submitLoading: false, form: this.defaultForm() });

  onFormInput = (key, value) =>
    this.setState((prev) => {
      const form = { ...prev.form, [key]: value };
      if (key === "payment_mode" && value === "manual") form.payment_provider = "";
      if (key === "charge_source" && value !== "credit") form.credit_balance = null;
      return { form };
    });

  onFormSelect = (key, option) => {
    if (!option) return;
    this.onFormInput(key, option.value);
    if (key === "charge_source" && option.value === "credit") setTimeout(() => this.loadCreditBalance(), 0);
  };

  loadCreditBalance = () => {
    const email = (this.state.form.email || "").trim();
    if (email === "" || this.state.form.charge_source !== "credit") return;
    apiBillingUserCreditBalance({ email }).then((res) => {
      const data = res.data;
      if (data.status === "ok" && data.record) {
        this.setState((prev) => ({ form: { ...prev.form, credit_balance: data.record.credit_balance } }));
      }
    }).catch((err) => console.error(err));
  };

  validateForm = () => {
    const f = this.state.form;
    const fee = Number(f.fee_percent);
    if ((f.email || "").trim() === "") return "User / Email is required";
    if ((f.phoneno || "").trim() === "") return "Phone is required";
    if (f.payment_mode === "gateway" && (f.payment_provider || "").trim() === "") return "Payment provider is required for gateway mode";
    if (Number.isNaN(fee) || fee < 0 || fee > 100) return "Fee percent must be between 0 and 100";
    if ((f.config_json || "").trim() !== "") {
      try { JSON.parse(f.config_json); } catch (e) { return "Config JSON must be valid JSON"; }
    }
    return "";
  };

  doSubmit = () => {
    if (this.state.formMode === "view") return this.handleCloseForm();
    const msg = this.validateForm();
    if (msg) return this.showValidation("Validation", msg);
    const f = this.state.form;
    const params = {
      id: f.id,
      email: f.email.trim(),
      phoneno: f.phoneno.trim(),
      payment_mode: f.payment_mode,
      payment_provider: f.payment_mode === "manual" ? "" : f.payment_provider,
      fee_percent: Number(f.fee_percent),
      charge_source: f.charge_source,
      is_active: Number(f.is_active) === 1 ? 1 : 0,
      config_json: f.config_json || "",
    };
    this.setState({ submitLoading: true });
    apiBillingUserSettingsSave(params).then((res) => {
      const data = res.data;
      if (data.status === "ok") {
        this.setState({ openSuccess: true, openSuccessText: data.message || "Data saved successfully" });
        this.handleCloseForm();
        this.doLoadData();
      } else {
        this.showValidation("Failed", data.message || "Failed to save data");
      }
    }).catch((err) => {
      console.error(err);
      this.showValidation("Failed", "Unable to save data");
    }).finally(() => this.setState({ submitLoading: false }));
  };

  openDelete = (row) => this.setState({ openAlertDelete: true, itemDeleted: row });
  handleCloseDelete = () => this.setState({ openAlertDelete: false, itemDeleted: {}, showLoadingDelete: false });

  doDelete = () => {
    const item = this.state.itemDeleted;
    if (!item || !item.id) return this.showValidation("Failed", "Invalid delete item");
    this.setState({ showLoadingDelete: true });
    apiBillingUserSettingsDelete({ id: item.id }).then((res) => {
      const data = res.data;
      if (data.status === "ok") {
        this.setState({ openSuccess: true, openSuccessText: data.message || "Data removed successfully" });
        this.handleCloseDelete();
        this.doLoadData();
      } else {
        this.showValidation("Failed", data.message || "Failed to remove data");
      }
    }).catch((err) => {
      console.error(err);
      this.showValidation("Failed", "Unable to remove data");
    }).finally(() => this.setState({ showLoadingDelete: false }));
  };

  renderActionButtons = (row) => (
    <div>
      <Button variant="contained" size="small" style={{ backgroundColor: "#1273DE" }} startIcon={<RemoveRedEye />} onClick={() => this.openView(row)}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>View</Typography></Button>&nbsp;
      <Button variant="contained" size="small" style={{ backgroundColor: "#3f51b5" }} startIcon={<Edit />} onClick={() => this.openEdit(row)}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>Edit</Typography></Button>&nbsp;
      <Button variant="contained" size="small" style={{ backgroundColor: "#ff0000" }} startIcon={<Delete />} onClick={() => this.openDelete(row)}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>Remove</Typography></Button>
    </div>
  );

  renderRowField = (label, control) => (
    <>
      <Grid item lg={3} md={3} xs={12} sm={12}><Typography component="span" variant="subtitle1" style={{ float: "left", marginTop: 6 }}>{label}</Typography></Grid>
      <Grid item lg={9} md={9} xs={12} sm={12}>{control}</Grid>
    </>
  );

  render() {
    const form = this.state.form;
    const isView = this.state.formMode === "view";
    const providerDisabled = isView || form.payment_mode === "manual";

    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper style={styleHeader}>
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}><Typography component="span" variant="h1" style={(stylesListComent.inline, { fontSize: 20, color: "#000", fontWeight: "bold" })}>User Billing Settings</Typography></Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 16 }}><Button variant="contained" size="small" style={{ backgroundColor: "#008b02" }} startIcon={<AddBox />} onClick={this.openAdd}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>Add Setting</Typography></Button></div>
                      <div style={{ marginRight: 0 }}><Button variant="contained" size="small" style={{ backgroundColor: "#1273DE" }} startIcon={<Refresh />} onClick={this.pressReset}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>Refresh</Typography></Button></div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {this.renderSuccess()}

        <Paper style={{ borderLeft: 6, borderColor: "#2f55a2", color: "#FFF", padding: 16, marginBottom: 12 }}>
          <Grid container spacing={2}>
            {this.renderRowField("Search Name / Email", <Input autoComplete="off" type="text" value={this.state.filterSearch} onChange={(e) => this.setState({ filterSearch: e.target.value })} />)}
            {this.renderRowField("Payment Mode", <Select classNamePrefix="select" options={filterPaymentModeOptions} value={this.state.filterPaymentMode} onChange={(val) => this.setState({ filterPaymentMode: val })} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
            {this.renderRowField("Provider", <Select classNamePrefix="select" options={filterProviderOptions} value={this.state.filterProvider} onChange={(val) => this.setState({ filterProvider: val })} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
            {this.renderRowField("Status", <Select classNamePrefix="select" options={filterStatusOptions} value={this.state.filterStatus} onChange={(val) => this.setState({ filterStatus: val })} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
            <Grid item lg={9} md={9} sm={12} xs={12}></Grid>
            <Grid item lg={3} md={3} sm={12} xs={12} style={{ display: "flex", justifyContent: "flex-end" }}><Button variant="contained" size="small" style={{ backgroundColor: "#1273DE" }} startIcon={<Search />} onClick={this.doLoadData}><Typography variant="button" style={{ color: "#fff", textTransform: "capitalize" }}>Search</Typography></Button></Grid>
          </Grid>
        </Paper>

        <div className="box-container">
          {this.state.loading ? <Box style={{ display: "flex", justifyContent: "center", padding: 32, backgroundColor: "#f2f2f2" }}><CircularProgress /></Box> : (
            <ReactTable ref={(r) => (this.reactTable = r)} data={this.state.tableData} columns={this.tableColumns} style={{ backgroundColor: "#f2f2f2" }} filterable defaultFilterMethod={defaultFilterMethod} defaultPageSize={500} showPageJump={false} showPageSizeOptions={false} showPagination={false} />
          )}
        </div>

        <Dialog open={this.state.openValidation} fullWidth={true} maxWidth="sm">
          <DialogTitle style={{ fontWeight: "bold" }}>{this.state.titleValidation || "Info"}</DialogTitle>
          <DialogContent><DialogContentText style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}>{this.state.titleBody}</DialogContentText></DialogContent>
          <DialogActions><Button color="primary" variant="contained" size="small" startIcon={<Check />} onClick={this.handleCloseValidation}>OK</Button></DialogActions>
        </Dialog>

        <Dialog open={this.state.openAlertDelete}>
          <DialogTitle style={{ fontWeight: "bold" }}>Delete Billing Setting?</DialogTitle>
          <DialogContent><DialogContentText style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}>Do you want to delete billing setting for <b>{this.state.itemDeleted.email || "-"}</b> ({this.state.itemDeleted.phoneno || "-"})?</DialogContentText></DialogContent>
          <DialogActions>
            <Button color="inherit" variant="contained" size="small" startIcon={<Close />} onClick={this.handleCloseDelete} disabled={this.state.showLoadingDelete}>Cancel</Button>
            <Button color="error" variant="contained" size="small" startIcon={this.state.showLoadingDelete ? null : <Check />} onClick={this.doDelete} disabled={this.state.showLoadingDelete}>{this.state.showLoadingDelete ? <CircularProgress size={24} color="inherit" /> : "Yes"}</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.setOpenForm} fullScreen={true}>
          <AppBar style={styleDialog.appBar}>
            <Toolbar>
              <Typography variant="h5" style={styleDialog.title}>{this.state.formMode === "add" ? "Add Billing Setting" : this.state.formMode === "edit" ? "Edit Billing Setting" : "View Billing Setting"}</Typography>
              <IconButton edge="end" color="inherit" onClick={this.handleCloseForm} aria-label="close"><Close /></IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent dividers>
            <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
              <Grid container spacing={2}>
                {this.renderRowField("User / Email", <Input autoComplete="off" type="text" value={form.email} onChange={(e) => this.onFormInput("email", e.target.value)} onBlur={this.loadCreditBalance} disabled={isView} />)}
                {this.renderRowField("Phone", <Input autoComplete="off" type="text" value={form.phoneno} onChange={(e) => this.onFormInput("phoneno", e.target.value)} disabled={isView} />)}
                {this.renderRowField("Payment Mode", <Select classNamePrefix="select" options={paymentModeOptions} value={this.getOption(paymentModeOptions, form.payment_mode)} onChange={(val) => this.onFormSelect("payment_mode", val)} isDisabled={isView} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
                {this.renderRowField("Payment Provider", <Select classNamePrefix="select" options={providerOptions} value={this.getOption(providerOptions, form.payment_provider)} onChange={(val) => this.onFormSelect("payment_provider", val)} isDisabled={providerDisabled} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
                {this.renderRowField("Fee Percent", <Input autoComplete="off" type="number" value={form.fee_percent} min={0} max={100} step={0.0001} onChange={(e) => this.onFormInput("fee_percent", e.target.value)} disabled={isView} />)}
                {this.renderRowField("Charge Source", <Select classNamePrefix="select" options={chargeSourceOptions} value={this.getOption(chargeSourceOptions, form.charge_source)} onChange={(val) => this.onFormSelect("charge_source", val)} isDisabled={isView} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
                {this.renderRowField("Active", <Select classNamePrefix="select" options={statusOptions} value={this.getOption(statusOptions, form.is_active)} onChange={(val) => this.onFormSelect("is_active", val)} isDisabled={isView} styles={selectStyles} menuPortalTarget={document.body} menuPosition={"fixed"} />)}
                {form.charge_source === "credit" ? this.renderRowField("Credit Balance", <Input autoComplete="off" type="text" value={form.credit_balance === null ? "N/A" : Number(form.credit_balance).toLocaleString()} disabled={true} />) : null}
                {this.renderRowField("Config JSON", <Input autoComplete="off" type="textarea" rows="8" value={form.config_json} onChange={(e) => this.onFormInput("config_json", e.target.value)} disabled={isView} />)}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" variant="contained" size="small" startIcon={<Cancel />} onClick={this.handleCloseForm} disabled={this.state.submitLoading}>Cancel</Button>
            {this.state.formMode !== "view" ? <Button color="primary" variant="contained" size="small" startIcon={this.state.submitLoading ? null : <Save />} onClick={this.doSubmit} disabled={this.state.submitLoading}>{this.state.submitLoading ? <CircularProgress size={24} color="inherit" /> : "Save"}</Button> : null}
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default UserBillingSettingsPage;
